module.exports = __webpack_public_path__ + "img/arrow_right_white.bd196d77.svg";